import React from 'react';
import { valuePropositions } from '../data/mock';
import { Check } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';

const ValueSection = () => {
  const { isDark } = useTheme();

  return (
    <section className={`py-16 sm:py-24 lg:py-32 relative overflow-hidden ${
      isDark ? 'bg-[#111916]' : 'bg-white'
    }`}>
      {/* Background decoration */}
      <div className={`absolute top-0 right-0 w-1/2 h-full ${
        isDark 
          ? 'bg-gradient-to-l from-green-900/10 to-transparent' 
          : 'bg-gradient-to-l from-green-50 to-transparent'
      }`} />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 relative z-10">
        <div className="grid lg:grid-cols-2 gap-10 sm:gap-12 lg:gap-16 items-center">
          {/* Left content */}
          <div>
            <p className={`font-medium text-xs sm:text-sm uppercase tracking-[0.2em] mb-3 sm:mb-4 ${
              isDark ? 'text-green-500' : 'text-green-600'
            }`}>
              Why Choose Us
            </p>
            <h2 className="font-display font-bold leading-tight mb-6 sm:mb-8" style={{ fontSize: 'clamp(1.75rem, 4vw, 3rem)' }}>
              <span className={isDark ? 'text-white' : 'text-gray-900'}>Committed to </span>
              <span className="gradient-text">Your Success</span>
            </h2>
            <p className={`text-sm sm:text-base lg:text-lg leading-relaxed ${
              isDark ? 'text-gray-400' : 'text-gray-600'
            }`}>
              As an indigenous top-notch company and a key player in the provision of first-class solutions, 
              we are dedicated to improving productivity, maximizing profit, and making life more comfortable 
              for homes and businesses across Nigeria.
            </p>
          </div>

          {/* Right - Value propositions list */}
          <div className={`rounded-xl sm:rounded-2xl p-6 sm:p-8 lg:p-10 border ${
            isDark 
              ? 'bg-[#1A2420] border-green-900/30' 
              : 'bg-gradient-to-br from-gray-50 to-white border-gray-100'
          }`}>
            <ul className="space-y-4 sm:space-y-5">
              {valuePropositions.map((value, index) => (
                <li key={index} className="flex items-start gap-3 sm:gap-4">
                  <div className="w-7 h-7 sm:w-8 sm:h-8 rounded-full bg-gradient-to-br from-[#006633] to-[#00873D] flex items-center justify-center flex-shrink-0 shadow-lg shadow-green-500/20">
                    <Check className="w-3 h-3 sm:w-4 sm:h-4 text-white" />
                  </div>
                  <p className={`text-sm sm:text-base font-medium pt-0.5 sm:pt-1 ${
                    isDark ? 'text-gray-300' : 'text-gray-700'
                  }`}>
                    {value}
                  </p>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ValueSection;
